import { COLORS, FlexView } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';

const Root = styled(FlexView)`
  min-width: 70px;
  background: ${({ color }) => color};
  padding: 2px 0;
  border-radius: 2px;
`;

const CapitalizedText = styled(Text)`
  text-transform: capitalize;
`;

function getColor(type) {
  switch (type) {
    case 'warning':
    case 'ptm_tag':
    case 'ref':
      return COLORS.SUN;
    case 'success':
    case 'demo_tag':
    case 'eval_tag':
      return COLORS.GRASS;
    case 'info':
      return COLORS.SKY_XLIGHT;
    case 'hybrid':
    case 'hybrid_plus':
      return COLORS.FLOWER;
    case 'plus':
    case 'black':
    case 'gen':
    case 'extra_tag':
      return COLORS.GRAY;
    case 'high':
      return COLORS.ORANGE;
    case 'regular':
      return COLORS.SKY;
    case 'cnf':
    case 'regular_tag':
      return COLORS.GHOST;
    case 'teacher_training_tag':
      return COLORS.SECONDARY;
    default:
      return COLORS.GRAY_XXLIGHT;
  }
}

export default function ColoredChip({ variant, children, color, background }) {
  return (
    <Root
      justifyContent="center"
      color={background || getColor(variant)}
      alignItems="center"
    >
      <CapitalizedText variant="body3" color={color || COLORS.COLA_LIGHTER}>
        {children}
      </CapitalizedText>
    </Root>
  );
}
